var _ref2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgSupport = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 28.896,
      height: 28.896,
      viewBox: "0 0 28.896 28.896",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      id: "_004-setting",
      "data-name": "004-setting",
      d: "M44.326,23.667A11.207,11.207,0,0,1,30.684,38L24.1,44.578a1.092,1.092,0,0,1-1.541,0l-6.244-6.244a1.092,1.092,0,0,1,0-1.541L22.9,30.212A11.207,11.207,0,0,1,37.23,16.571L30,23.8l1.5,5.6,5.6,1.5Z",
      transform: "translate(-16 -16)",
      fillRule: "evenodd"
    })))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgSupport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Support.dfeec281.svg";
export { ForwardRef as ReactComponent };